import { render } from "./App.vue?vue&type=template&id=75823770&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=75823770&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75823770"]])

export default __exports__